import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3938a733: FaireBrandEntity = {
  token: "b_3938a733",
  type: "brand",
  name: "DANI Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/ee1d9855af65e2d86d392c016cc52211850b19c1c3435e3ef5999f90af3568c6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/caafc3253d2b1d6ea690ad3d28355cb492cfc98d464645f577f163b9e8f50cbb.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ee1d9855af65e2d86d392c016cc52211850b19c1c3435e3ef5999f90af3568c6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/caafc3253d2b1d6ea690ad3d28355cb492cfc98d464645f577f163b9e8f50cbb.jpeg",
  location: "Bend, OR, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 99,
  isInsider: true,
  description:
    "At DANI Naturals, we’re passionate about self care and living well. As a small soap and candle company started in 1996, we've transformed into today’s thriving, woman-powered lifestyle company where our core promise remains delivering more joy and self-care at home.\n\nToday, DANI Naturals’ bath, body, hair & home care products are handcrafted in beautiful Bend, Oregon using the best that nature has to offer—with scents so delicious they’ll all become favorites. We make products that nurture a happy home and planet, with thoughtfully sourced ingredients, recyclable packaging and a whole lot of love.\nAt DANI Naturals, we use only the purest, organic & natural ingredients, with no parabens, phthalates, sulfates, or petroleum. \n\nWe scent our products with custom, essential oil blends ensuring only the highest quality, safest products.  With scents ranging from Coconut Hibiscus to Grapefruit Ginger and Bamboo Bergamot to Sandalwood Vanilla, all 6 scents are sure to delight any customer in any product!\n\nDANI Naturals is made in the USA, eco-friendly, vegan, cruelty-free (Leaping Bunny Certified), and proudly female-owned and operated.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:12.028Z",
    importedBy: "entity-db-cli",
  },
};
